var _excluded = ["ref"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { useCreateElement as _useCreateElement } from "reakit-system";
import { usePopover } from "reakit";
import { useForkRef } from "reakit-utils";
import { useWarning } from "reakit-warning";
import { createComponent, createHook } from "../system";
import { SELECT_POPOVER_KEYS } from "./__keys";
import { useTypeaheadShortcut } from "./helpers";
import { useSelectList } from "./SelectList";
export var useSelectPopover = createHook({
  name: "SelectPopover",
  compose: [useSelectList, usePopover],
  keys: SELECT_POPOVER_KEYS,

  useProps(options, _ref) {
    var {
      ref: htmlRef
    } = _ref,
        htmlProps = _objectWithoutProperties(_ref, _excluded);

    var ref = React.useRef(null);
    useTypeaheadShortcut({
      options,
      ref
    });
    return _objectSpread({
      ref: useForkRef(ref, htmlRef),
      role: "listbox"
    }, htmlProps);
  }

});
export var SelectPopover = createComponent({
  as: "div",
  useHook: useSelectPopover,
  useCreateElement: (type, props, children) => {
    useWarning(!props["aria-label"] && !props["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://www.w3.org/TR/wai-aria-1.1/#listbox");
    return _useCreateElement(type, props, children);
  }
});
//# sourceMappingURL=SelectPopover.js.map